import { useEffect, useState } from 'react';

export const useWheelCountdown = (
  spinTime: Date | null,
  onCountdownFinish: () => void
) => {
  const [countdown, setCountdown] = useState('');

  useEffect(() => {
    if (!spinTime) {
      return undefined;
    }

    const interval = setInterval(() => {
      const now = new Date();
      const targetDate = new Date(spinTime);
      const timeDifference = targetDate.getTime() - now.getTime();

      if (timeDifference <= 0) {
        onCountdownFinish();
        clearInterval(interval);
        setCountdown('');
      } else {
        const hours = Math.floor((timeDifference / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((timeDifference / (1000 * 60)) % 60);
        const seconds = Math.floor((timeDifference / 1000) % 60);
        setCountdown(
          `${String(hours).padStart(2, '0')}:${String(minutes).padStart(
            2,
            '0'
          )}:${String(seconds).padStart(2, '0')}`
        );
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [spinTime, onCountdownFinish]);

  return { countdown, setCountdown };
};
